export default __webpack_public_path__ + "static/media/BodyMind.cf9c9acd.png";